// @flow
import { add, assign, concat, filter, subtract } from 'lodash';

const initialState = {
    dashboards: [],
    dashboardsError: null,
    reports: [],
    grids: [],
    notificationCount: 0,
    notifications: [],
    user: null,
    users: [],
    versionFlags: [],
};

export default function appState(state: State = initialState, action: Action) {
    switch (action.type) {
        case 'LOGIN':
            return assign({}, state, { user: action.user });
        case 'LOGOUT':
            return assign({}, state, { user: initialState.user });
        case 'NOTIFICATIONS/ADD':
            return assign({}, state, {
                notificationCount: add(state.notificationCount, 1),
                notifications: concat(state.notifications, {
                    message: action.notification.message,
                    style: action.notification.style,
                    key: add(state.notificationCount, 1),
                    dismissAfter: 2000,
                }),
            });
        case 'NOTIFICATIONS/REMOVE':
            return assign({}, state, {
                notificationCount: subtract(state.notificationCount, 1),
                notifications: filter(state.notifications, (el) => el.key !== action.key),
            });
        case 'SET_DASHBOARDS':
            return assign({}, state, { dashboards: action.dashboards, dashboardsError: null });
        case 'SET_DASHBOARDS_ERROR':
            return assign({}, state, { dashboards: [], dashboardsError: action.message });
        case 'SET_REPORTS':
            return assign({}, state, { reports: action.reports });
        case 'SET_GRIDS':
            return assign({}, state, { grids: action.grids });
        case 'SET_USERS':
            return assign({}, state, { users: action.users });
        case 'SET_VERSION_FLAGS':
            return assign({}, state, { versionFlags: action.versionFlags });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./modules/reducers.js